import { Component } from '@angular/core';

@Component({
  selector: 'app-loggedin-home',
  templateUrl: './loggedin-home.component.html',
  styleUrls: ['./loggedin-home.component.scss']
})
export class LoggedinHomeComponent {
  constructor() {}
}
